module.exports = __webpack_public_path__ + "static/media/ecoicons.f7536491.ttf";